import Vue from "vue";
import { MutationTree } from "vuex";
import { ISlotState } from "./state";
import { ISlot } from "@/models";
import { SET_SLOTS } from "./mutations-types";

export const mutations: MutationTree<ISlotState> = {
    [SET_SLOTS](state, payload: ISlot[]): void {
        state.slots = payload;
    },
};
